<template>
    <img height="24" width="24" src="./auracoin.png" style="height: 24px!important; width: 24px!important" />
</template>
